import Promise from 'bluebird'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'

import {
  setHTTPToken,
  unsetHTTPToken,
  getHTTPTokenHeaders,
  handlers,
} from '../utils/api'

import networkWrapper from '../utils/networkWrapper'
import routerActions from './router'
import adminActions from './admin'
import projectActions from './project'
import bookingActions from './booking'

import {
  REFRESH_TOKEN_DELAY,
  ROUTE_LOGGED_IN,
  ROUTE_LOGGED_OUT,
} from 'settings'

const prefix = 'auth'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  loaded: false,
  tokenerror: null,
  data: null,
}

const reducers = {
  setUser: (state, action) => {
    state.loaded = true
    state.data = action.payload
  },
  setTokenError: (state, action) => {
    state.tokenerror = action.payload
  }
}

const setToken = (token) => {
  setHTTPToken(token)
  localStorage.setItem('token', token)
}

const unsetToken = () => {
  unsetHTTPToken()
  localStorage.setItem('token', '')
}

let refreshTokenLoop = null

const sideEffects = {

  authenticate: (token) => async (dispatch, getState) => {
    const pathName = window.location.pathname

    localStorage.removeItem('admin_login_pathname')

    let user = null
    token = token || localStorage.getItem('token')
    if(token) {
      try {
        user = await handlers.get('/auth/status', null, {
          headers: getHTTPTokenHeaders(token),
        })
      } catch(e) {

      }
    }
    if(user && user.id) {
      setToken(token)
      await dispatch(projectActions.loadAdminProjects())
      await dispatch(projectActions.loadUserRole())
      await dispatch(adminActions.loadConfig())
      dispatch(actions.startTokenLoop())
      dispatch(actions.setUser(user))
    }
    else {
      unsetToken()
      dispatch(actions.setUser(null))
      if(pathName.indexOf('/admin/') == 0 && pathName.indexOf('/admin/login') < 0) {
        localStorage.setItem(`admin_login_pathname`, pathName)
      }      
    }
  },

  startTokenLoop: () => (dispatch, getState) => {
    clearInterval(refreshTokenLoop)
    refreshTokenLoop = setInterval(() => {
      dispatch(actions.refreshToken())
    }, REFRESH_TOKEN_DELAY)
  },

  stopTokenLoop: () => (dispatch, getState) => {
    clearInterval(refreshTokenLoop)
  },

  refreshTokenRequest: () => async (dispatch, getState) => {
    try {
      const { token } = await handlers.post('/auth/token')
      setToken(token)
      return true
    } catch(e) {
      return false
    }
  },

  refreshToken: () => async (dispatch, getState) => {
    let hasTokenRefreshed = false
    let attempts = 0
    while(!hasTokenRefreshed && attempts < 5) {
      attempts++
      hasTokenRefreshed = await dispatch(actions.refreshTokenRequest())
      await Promise.delay(1000)
    }
    if(!hasTokenRefreshed) {
      await dispatch(actions.logout())
      dispatch(actions.setTokenError(`you have been inactive and the system has logged you out`))
    }
    else {
      dispatch(actions.setTokenError(null))
    }
  },

  register: ({
    email,
    password,
  }) => wrapper('register', async (dispatch, getState) => {
    const {
      token,
    } = await handlers.post('/auth/register', {
      email,
      password,
    })
    await dispatch(actions.authenticate(token))
    dispatch(routerActions.navigateTo(ROUTE_LOGGED_IN))
  }),

  login: ({
    email,
    password,
  }) => wrapper('login', async (dispatch, getState) => {
    const {
      token,
    } = await handlers.post('/auth/login', {
      email,
      password,
    })
   
    await dispatch(actions.authenticate(token))
    const adminLoginPath = localStorage.getItem(`admin_login_pathname`)
    if(adminLoginPath) {
      window.location = adminLoginPath
    }
    else {
      dispatch(routerActions.navigateTo(ROUTE_LOGGED_IN))  
    }
  }),

  logout: () => wrapper('logout', async (dispatch, getState) => {
    unsetToken()
    dispatch(actions.stopTokenLoop())
    dispatch(actions.setUser(null))
    dispatch(actions.setTokenError(null))
    dispatch(routerActions.navigateTo(ROUTE_LOGGED_OUT))
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions